export default "__VITE_ASSET__DKQEMcrC__"